/**
 * @author Sai Prasad
 * @class TileHeader
 */

import React from 'react';
import Button from '../Button';
import Icon from '../Icon';
const TileHeader = ({
    heading,
    data,
    onNavigate,
    onSetServiceRequestFormIsVisible
}) => {
    let theme = localStorage.getItem('theme');
    return (
        <>
        <div style={{ display: 'flex' }}>
            <div style={{ width: '80%' }}>
                <label className='homeDasboard__title'>{heading}</label>
            </div>
            {data && data.length > 0 &&
                <div style={{ width: '20%' }} onClick={onNavigate}>
                    <div className='homeDasboard__viewAll'
                        style={{ cursor: 'pointer' }}>VIEW ALL
                    </div>
                </div>
            }
        </div>
        {theme ==="Panatch" && heading === "SERVICE REQUESTS" &&  
                <>
                <br/>
                  <Button
                    color="teal"
                    label="Create Request"
                    onClick={() => onSetServiceRequestFormIsVisible(true)}
                    icon={<Icon glyph="wrench" weight="light" size="small" />}
                    size="small"
                    /> 
                <br/>
                </>
                  }
        </>
    )
}

export default TileHeader;